import { IBookingQuestions } from "@my-scoot/exly-react-component-lib/build/types/features/EUD/modules/BookingQuestions/IBookingQuestions";
import { api } from "data";
import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";

export const useGetBookingQuestions = ({
  listingUuid,
  onSuccess,
}: {
  listingUuid: string;
  onSuccess: (data: {
    listing_questions: IBookingQuestions.IQuestion[];
  }) => void;
}) => {
  return useCustomQuery({
    url: api.questions.get_questions,
    queryKey: [api.questions.get_questions],
    params: {
      listing_uuid: listingUuid,
    },
    cacheTime: 0,
    onSuccess: onSuccess,
  });
};
